var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({class:_vm.gatedClass,attrs:{"to":_vm.gatedTo,"active-class":_vm.activeClass},on:{"click":function($event){_vm.onAction($event, 'click')}}},'router-link',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }